/* SolNow — store de las columnas dinámicas del tablero (Pinia via storeFactory) */
import TicketColumnsAPI from 'dashboard/api/ticketColumns';
import { createStore } from 'dashboard/store/storeFactory';

export const useTicketColumnsStore = createStore({
  name: 'ticketColumns',
  type: 'pinia',
  API: TicketColumnsAPI,

  getters: {
    // Columnas ordenadas por posición para renderizar el tablero.
    getColumns: state =>
      [...state.records].sort((a, b) => a.position - b.position),
  },

  actions: () => ({
    async reorder(ids) {
      const { data } = await TicketColumnsAPI.reorder(ids);
      this.records = data.payload || data;
    },
  }),
});
